import React from 'react';
import irelandApi from '../irelandApi';
import { toast } from 'react-toastify';
import ToastMessage from '../components/common/toast-message';
import Error from '../components/elearning/error';

export const getSamlResponse = () => (dispatch) => {
  dispatch({
    type: 'SAML_RESPONSE_PENDING',
  });
  return irelandApi.post('/api/saml_responses')
                   .then((response) => {
                     dispatch({
                       type: 'SAML_RESPONSE_FULFILLED',
                       payLoad: {
                         samlResponse: response.data.saml_response
                       }
                     })
                   })
                   .catch((error) => {
                   toast.error(<ToastMessage
                                iconStyle="error"
                                message={(<Error />)}
                               />);
                     dispatch({
                       type: 'SAML_RESPONSE_REJECTED',
                     });
                     return Promise.reject(error);
                   });
};



// WEBPACK FOOTER //
// ./src/actions/saml.js